export default __webpack_public_path__ + "static/media/label.a00d1fc0.jpg";